import type { PicoSanity } from "picosanity";
import { createClient } from "picosanity";

import { config } from "./config";

// Set up the environment variables based on the context
const env = typeof document === "undefined" ? process.env : window.ENV;

// Set the appropriate Sanity configuration based on the environment
const sanityClient = createClient(config);

const previewClient = createClient({
  ...config,
  useCdn: false,
  token: env.SANITY_API_TOKEN || "",
});

// We want to time the async fetch calls to Sanity so // we create a proxy that
// wraps the client and logs the time taken for each fetch call.
const timedClient = (client: PicoSanity, name: string) => {
  return new Proxy(client, {
    get(target, prop) {
      // We expect an error so ignore linting for this line
      // @ts-expect-error Property access could be anything for proxy
      const originalMethod = target[prop];
      if (typeof originalMethod === "function" && prop === "fetch") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return async (...args: any[]) => {
          const rand = Math.floor(Math.random() * 1000);
          const label = `${name}.${prop}-${rand}`;
          // Log the query and the time it took to fetch the data
          console.time(label);
          const result = await originalMethod.apply(target, args);
          console.timeEnd(label);
          // const query = args[0].replace(/\n/g, " ").replace(/\s+/g, " ").trim();
          // console.log(`${label}: ${args[0]}`);
          return result;
        };
      }
      return originalMethod;
    },
  });
};

export const getClient = (usePreview = false) => {
  const client = usePreview ? previewClient : sanityClient;

  if (env.MODE === "dev") {
    return timedClient(client, "sanityClient");
  }

  return client;
};
